import { render } from "./FD2024StoriesSection.vue?vue&type=template&id=096a4d43"
import script from "./FD2024StoriesSection.vue?vue&type=script&lang=js"
export * from "./FD2024StoriesSection.vue?vue&type=script&lang=js"

import "./FD2024StoriesSection.vue?vue&type=style&index=0&id=096a4d43&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__